import { BreadcrumbItem } from "~/components/Breadcrumbs";
import { getValueByAssetClassID } from "~/utils/getValueByAssetClass";
import {
    ASSET_CLASS_PAGE_TO_LABEL,
    ASSET_CLASS_PAGE_TO_ROUTE,
} from "~/modules/asset_classes/metadata";

// // // //

const TREASURY_PRODUCTS_BREADCRUMB: BreadcrumbItem = {
    name: "U.S. Treasury Funds",
    href: ASSET_CLASS_PAGE_TO_ROUTE.treasuries,
};

const STABLECOINS_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.stablecoins,
    href: ASSET_CLASS_PAGE_TO_ROUTE.stablecoins,
};

const COMMODITIES_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.commodities,
    href: ASSET_CLASS_PAGE_TO_ROUTE.commodities,
};

const PUBLIC_EQUITY_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.stocks,
    href: ASSET_CLASS_PAGE_TO_ROUTE.stocks,
};

const GOVERNMENT_BONDS_BREADCRUMB: BreadcrumbItem = {
    name: "Non-U.S. Government Debt",
    href: ASSET_CLASS_PAGE_TO_ROUTE.government_bonds,
};

const CREDIT_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.credit,
    href: ASSET_CLASS_PAGE_TO_ROUTE.credit,
};

const REAL_ESTATE_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.real_estate,
    href: ASSET_CLASS_PAGE_TO_ROUTE.real_estate,
};

const PRIVATE_EQUITY_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.pe_vc,
    href: ASSET_CLASS_PAGE_TO_ROUTE.pe_vc,
};

const ACTIVE_STRATEGIES_BREADCRUMB: BreadcrumbItem = {
    name: ASSET_CLASS_PAGE_TO_LABEL.active_strategies,
    href: ASSET_CLASS_PAGE_TO_ROUTE.active_strategies,
};

// // // //

// Returns null for asset classes without a dedicated page (e.g.
// Cryptocurrencies) instead of falling back to another asset class page
export function getAssetClassBreadcrumb(props: {
    asset_class_id: number | null;
}): BreadcrumbItem | null {
    return getValueByAssetClassID<BreadcrumbItem | null>({
        assetClassID: props.asset_class_id,
        values: {
            stablecoin: STABLECOINS_BREADCRUMB,
            treasury: TREASURY_PRODUCTS_BREADCRUMB,
            commodity: COMMODITIES_BREADCRUMB,
            stocks: PUBLIC_EQUITY_BREADCRUMB,
            non_us_government_debt: GOVERNMENT_BONDS_BREADCRUMB,
            real_estate: REAL_ESTATE_BREADCRUMB,
            active_strategies: ACTIVE_STRATEGIES_BREADCRUMB,
            private_equity: PRIVATE_EQUITY_BREADCRUMB,
            venture_capital: PRIVATE_EQUITY_BREADCRUMB,
            diversified_credit: CREDIT_BREADCRUMB,
            asset_backed_credit: CREDIT_BREADCRUMB,
            specialty_finance: CREDIT_BREADCRUMB,
            municipal_bonds: CREDIT_BREADCRUMB,
            corporate_credit: CREDIT_BREADCRUMB,
        },
        fallbackValue: null,
    });
}
